// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkExpired__container-e4e2de {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.LinkExpired__title-a4d7e6 {
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
  color: var(--base-110);
  margin-bottom: 4px;
  text-align: center;
}

.LinkExpired__sub-title-c1ceac {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-80);
  max-width: 360px;
  text-align: center;
}

.LinkExpired__logo-f82016 {
  margin-bottom: 24px;
}

.LinkExpired__logo-show-bd9fc6 {
  display: none;
}

@media (max-width: 428px) {
  .LinkExpired__logo-show-bd9fc6 {
    display: inline-block;
    width: 80px;
    margin-bottom: 32px;
  }
  .LinkExpired__sub-title-c1ceac {
    max-width: 332px;
  }
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/LinkExpired/LinkExpired.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE;IACE,qBAAA;IACA,WAAA;IACA,mBAAA;EACF;EAEA;IACE,gBAAA;EAAF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.title {\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n  color: var(--base-110);\n  margin-bottom: 4px;\n  text-align: center;\n}\n\n.sub-title {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-80);\n  max-width: 360px;\n  text-align: center;\n}\n\n.logo {\n  margin-bottom: 24px;\n}\n\n.logo-show {\n  display: none;\n}\n\n@media (max-width: 428px) {\n  .logo-show {\n    display: inline-block;\n    width: 80px;\n    margin-bottom: 32px;\n  }\n\n  .sub-title {\n    max-width: 332px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LinkExpired__container-e4e2de`,
	"title": `LinkExpired__title-a4d7e6`,
	"sub-title": `LinkExpired__sub-title-c1ceac`,
	"subTitle": `LinkExpired__sub-title-c1ceac`,
	"logo": `LinkExpired__logo-f82016`,
	"logo-show": `LinkExpired__logo-show-bd9fc6`,
	"logoShow": `LinkExpired__logo-show-bd9fc6`
};
module.exports = ___CSS_LOADER_EXPORT___;
